// removed by extract-text-webpack-plugin
module.exports = {"Container":"terms__Container__3oEdY","BackgroundContainer":"terms__BackgroundContainer__2dMX0","Background":"terms__Background__dq39Q","Tagline":"terms__Tagline__1XpLg","DetailDescription":"terms__DetailDescription__sKHUy","Address":"terms__Address__36Sl1","Banner":"terms__Banner__Ju1lu","Sup":"terms__Sup__nZjpn","Image":"terms__Image__95aM3","Content":"terms__Content__1ESR1","Description":"terms__Description__23m-9","Link":"terms__Link__3BCdg","Links":"terms__Links__1D59n terms__Link__3BCdg"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Terms/terms.css
// module id = 1244
// module chunks = 2